/*
 * @Author: CYX
 * @Date: 2020-05-12 11:44:46
 * @LastEditors: CYX
 * @LastEditTime: 2020-07-10 16:42:41
 */ 
export const integralCn = {
    xunjiadang:'积分管理',
    wodejifeng:'我的积分',
    linquyouhuiquan:'领取优惠券',
    zuijinsangeyue:'最近3个月积分统计',
    jifengmingxi:'积分明细',
    jifenghuoqu:'积分获取类型',
    qingshuru:'请输入服务名称关键字',
    sousuo:'搜索',
    qingxuanzhe:'请选择',
    laiyuan:'来源/用途',
    jifengbianhua:'积分变化',
    riqi:'日期',
    beizhu:'备注',
    lingquyhq: "积分管理 - 领取优惠券",
    jifenglq: "积分领取",
    duihuanmalq: "兑换码领取",
    sfkdh: "是否可兑换：",
    zhifengzhi: "积分值：",
    jifengyt: "积分用途",
    shengyusl: "剩余数量",
    lingquzf: "领取积分",
    xianlingsl: "限领数量",
    lijilingqu: "立即领取",
    qsryhqdhm: "请输入优惠券兑换码：",
    shuoming: "请注意兑换码的有效期,逾期的兑换码将无法兑换优惠券",
    qsryzm: "请输入验证码：",
    kanbuqinghyz: "看不清，换一张",
    shuoming2: "请注意如果您已经通过其他渠道领取了优惠券,您将无法通过兑换码领取",
    gxnlqcg: "恭喜您，领取成功!",
    lingqucg: "领取成功后，您可在“我的优惠券”中查看",
    lingqusb: "抱歉，您的积分不够，领取失败！",
    bukeduihuan: "不可兑换",
    keduihuan: "可兑换",
    xaiofeizf: "消费积分",
    pinglunzf: "评论积分",
    shiyongzf: "使用积分",
  }
  


// WEBPACK FOOTER //
// ./src/lang/member/integral/integralCn.js